(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .requires
    .push(
      'ngTable'
      , 'pikaday'
      , 'ngSanitize'
      , 'foundation'
    );

  angular.module('MktzapApp.Controllers')
    .controller('PocsController', pocs);

  pocs.$inject = ['$scope', 'FoundationApi', 'LangService', '$http', 'ngTableParams', '$sce'];

  function pocs ($scope, FoundationApi, LangService, $http, ngTableParams, $sce) {
    var vm = this;

    LangService
      .getPageLabels({ 'page': 'pocs' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });

    vm.pocsTable = new ngTableParams({
      page: 1, // show first page
      count: 10 // count per page
    }, {
      getData: function ($defer, params) {
        $http.get(apiUrl + '/pocs', {
          params: params.url()
        })
          .then(function ({ data, status, headers, config }) {
            params.total(data.total);
            $defer.resolve(data.data);
          }, function (error) { console.log(error) });
      }
    });

    vm.generatePoc = function () {
      $http.post(apiUrl + '/pocs/generate')
        .then(function () {
          FoundationApi.publish('main-notifications', { title: vm.labels.new, content: vm.labels.newURL, color: 'success' });
          vm.pocsTable.reload();
        }, function (error) { console.log(error) });
    };

    vm.createCompany = function (poc_id) {
      $http.post(apiUrl + '/pocs/export', { id: poc_id })
        .then(function () {
          FoundationApi.publish('main-notifications', { title: vm.labels.exported, content: vm.labels.newCompany, color: 'success' });
          vm.pocsTable.reload();
        }, function (error) { console.log(error) });
    };
  }
})();
